<template>
  <modal
    :show.sync="showLinkModal"
    :on-close="onClose"
    custom-classes="link-modal"
    class="modal-border"
  >
    <woot-modal-header
      :header-title="$t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.TITLE')"
      :header-content="
        $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.DESCRIPTION')
      "
    />
    <div v-if="showAlertError" class="alert-modal">
      <p>
        {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.ERRORS.LINKING_ERROR') }}
      </p>
    </div>
    <div class="link-container">
      <div class="instructions">
        <ol>
          <li>
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_1'
              )
            }}
          </li>
          <li>
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_1'
              )
            }}
            <fluent-icon
              width="24"
              height="32"
              viewbox="0 0 24 32"
              icon="settings-android"
              type="solid"
              class="icon-android"
            />
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_2'
              )
            }}
            <img
              :src="'/assets/images/conversa2/settings_iphone.png'"
              class="icon-ios"
            />
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_2.PART_3'
              )
            }}
          </li>

          <li>
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_3'
              )
            }}
          </li>
          <li>
            {{
              $t(
                'INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.INSTRUCTIONS.STEP_4'
              )
            }}
          </li>
        </ol>
        <a
          :href="
            $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.HELP_LINK.URL')
          "
          target="_blank"
          class="help-link"
        >
          {{
            $t('INBOX_MGMT.ADD.EVOLUTION_API.LINK_NUMBER_STEP.HELP_LINK.TEXT')
          }}
        </a>
      </div>
      <div class="qr-container">
        <div
          v-if="displayRefreshOverlay"
          class="qr-overlay"
          @click="refreshQrCode"
        >
          <div class="overlay-content">
            <fluent-icon
              size="32"
              viewbox="0 0 33 32"
              icon="replay"
              class="refresh-icon"
              type="solid"
            />
            <p class="refresh-text">
              {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.QR_REFRESH_TEXT') }}
            </p>
          </div>
        </div>
        <img
          :src="qrcode"
          alt="QR Code"
          class="qr-code"
          :class="{ 'qr-code-faded': displayRefreshOverlay }"
        />
      </div>
    </div>
    <button class="button link-modal-close-button primary" @click="onClose">
      <span>{{ $t('INBOX_MGMT.ADD.EVOLUTION_API.BUTTONS.BACK_BUTTON') }}</span>
    </button>
  </modal>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';

export default {
  components: { Modal },
  props: {
    showLinkModal: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    showAlertError: {
      type: Boolean,
      default: false,
    },
    qrcode: {
      type: String,
      default: '',
    },
    displayRefreshOverlay: {
      type: Boolean,
      default: false,
    },
    refreshQrCode: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.link-modal.modal-container {
  width: auto;
}
</style>
<style scoped lang="scss">
.modal-border {
  border: 1px solid var(--conversa2-neutral-800-color);
}

.link-container {
  display: flex;
  align-items: center;
  padding: 32px;
  padding-top: 0;
  gap: 8rem;
}

.qr-container {
  position: relative;
  max-width: 400px;
  background: #fff;
}

.qr-code {
  width: 264px;
  height: 264px;
  background: black;
}

.qr-code-faded {
  opacity: 0.06;
}

.qr-overlay {
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(
    -50%,
    -50%
  ); /* Shift the element back by half its width and height */
  position: absolute;
  width: 190px;
  height: 190px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000000;
  z-index: 20;
  cursor: pointer; /* Cambia el cursor para indicar que es clickable */
}

.overlay-content {
  text-align: center;
}

.refresh-icon {
  color: white;
  margin-bottom: var(--space-one);
}

.refresh-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
}

.instructions {
  width: 73rem;
}

.instructions p {
  font-weight: var(--font-weight-normal);
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0;
}

.instructions ol {
  margin-left: 2.25rem;
}

.instructions li {
  padding: var(--space-small);
  font-weight: var(--font-weight-normal);
  font-size: 1.4rem;
  line-height: 1.45;
  letter-spacing: 0;
}

.link-modal-close-button {
  width: 10.3rem;
  justify-content: center;
  margin: 32px;
  margin-top: 0;
}

.alert-modal {
  border: 2px solid var(--conversa2-red-900-color);
  background-color: var(--conversa2-red-100-color);
  border-radius: var(--space-smaller);
  margin-left: var(--space-large);
  margin-right: var(--space-large);
  margin-top: 32px;
  margin-bottom: 32px;

  display: flex;
  padding: 16px 20px;
  justify-content: center;
  gap: 10px;

  p {
    color: var(--conversa2-red-900-color);
  }
}

.icon {
  font-weight: bold;
}

.help-link {
  font-weight: var(--font-weight-normal);
  font-size: 1.4rem;
  line-height: 1.45;
  letter-spacing: 0px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: Auto;
  text-decoration-thickness: Auto;
  color: var(--conversa2-blue-700-color);
}

.icon-android {
  border-radius: var(--border-radius-normal-small);
  border-width: 1px;
  background: var(--conversa2-neutral-50-color);
  border: 1px solid var(--conversa2-neutral-300-color);
  vertical-align: middle;
}

.icon-ios {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-normal-plus);
  vertical-align: middle;
}
</style>
